export const slidesMeta = [
  { index: '01', label: 'Hearing Care', tone: 'dark', ambient: 'signal' },
  { index: '02', label: 'Evaluation Battery', tone: 'light', ambient: 'quiet' },
  { index: '03', label: 'ASHA References', tone: 'light', ambient: 'quiet' },
  { index: '04', label: 'Ear Anatomy', tone: 'dark', ambient: 'anatomy' },
  { index: '05', label: 'Al Rahba Hospital', tone: 'dark', ambient: 'quiet' },
  { index: '06', label: 'Location', tone: 'light', ambient: 'location' },
  { index: '07', label: 'Catchment Population', tone: 'light', ambient: 'network' },
  { index: '08', label: 'Statistics', tone: 'dark', ambient: 'signal' },
  { index: '09', label: 'Schools Screening', tone: 'light', ambient: 'quiet' },
  { index: '10', label: 'Market Opportunity', tone: 'dark', ambient: 'quiet' },
  { index: '11', label: 'Locations & Branches', tone: 'light', ambient: 'location' },
  { index: '12', label: 'Thank You', tone: 'dark', ambient: 'signal' },
];

export const adultTests = [
  { code: '92550', label: 'Tympanometry and reflex threshold measurements', value: '195' },
  { code: '92588', label: 'Diagnostic OAE', value: '640' },
  { code: '92557', label: 'Comprehensive Audio & Speech', value: '350' },
];

export const pediatricTests = [
  { code: '92550', label: 'Tympanometry and reflex threshold measurements', value: '195' },
  { code: '92588', label: 'Diagnostic OAE', value: '640' },
  { code: '92652', label: 'Auditory evoked potentials; for threshold estimation at multiple frequencies, with interpretation and report', value: '945' },
  { code: '92582', label: 'Conditioning play audiometry', value: '500' },
  { code: '92651', label: 'Auditory evoked potentials; for hearing status determination, broadband stimuli, with interpretation and report', value: '720' },
];

export const populationZones = [
  { name: 'Al Samha', value: 6900, x: 17, y: 31 },
  { name: 'Al Rahba', value: 12000, x: 50, y: 50, hub: true },
  { name: 'Al Shahama', value: 28000, x: 78, y: 24 },
  { name: 'Al Falah', value: 35000, x: 79, y: 73 },
  { name: 'Al Bahia', value: 23000, x: 22, y: 76 },
];

export const anatomyParts = [
  { id: 'auricle', label: 'Auricle', group: 'External Ear', x: 17, y: 52, scale: 1.95, tx: 24, ty: -4 },
  { id: 'canal', label: 'External auditory canal', group: 'External Ear', x: 39, y: 56, scale: 2.05, tx: -6, ty: -7 },
  { id: 'membrane', label: 'Tympanic membrane', group: 'Middle Ear', x: 49, y: 60, scale: 2.35, tx: -28, ty: -15 },
  { id: 'ossicles', label: 'Auditory ossicles', group: 'Middle Ear', x: 59, y: 43, scale: 2.3, tx: -44, ty: 0 },
  { id: 'cochlea', label: 'Cochlea', group: 'Inner Ear', x: 79, y: 58, scale: 2.25, tx: -70, ty: -13 },
  { id: 'canals', label: 'Semicircular canals', group: 'Inner Ear', x: 69, y: 31, scale: 2.15, tx: -56, ty: 22 },
  { id: 'nerve', label: 'Vestibulocochlear nerve (N VIII)', group: 'Inner Ear', x: 86, y: 44, scale: 2.1, tx: -78, ty: 2 },
];

export const ashaReferences = [
  {
    title: 'Hearing Loss in Adults',
    body: 'Hearing loss refers to a partial or total inability to hear. It can result from problems with the ear (outer, middle, and/or inner), the vestibulocochlear nerve (i.e., cranial nerve eight or CN VIII), and/or the auditory system.',
    url: 'https://www.asha.org/practice-portal/clinical-topics/hearing-loss/',
  },
  {
    title: 'Hearing Loss in Children',
    body: 'Permanent childhood hearing loss is the loss of hearing ability at a young age. It may be congenital, delayed-onset, progressive, or acquired.',
    url: 'https://www.asha.org/practice-portal/clinical-topics/hearing-loss-in-children/',
  },
];

export const marketRows = [
  { label: 'Primary catchment population', value: '≈105,000' },
  { label: 'Schools within 10 km', value: '14' },
  { label: 'Estimated students', value: '≈13,000' },
  { label: 'Existing TOH SEHA patients from Dubai & Northern Emirates', value: '40%' },
];

export const branches = [
  { name: 'TOHRC', x: 58.22, y: 46.08, labelSide: 'right' },
  { name: 'BMC', x: 35.37, y: 55.21, labelSide: 'right' },
  { name: 'MPC', x: 42.12, y: 59.67, labelSide: 'right' },
  { name: 'NMC', x: 48.19, y: 57.66, labelSide: 'right' },
  { name: 'NMC Royal Khalifa', x: 27.63, y: 59.25, labelSide: 'right' },
  { name: 'TOH Jumeirah', x: 66.57, y: 36.86, labelSide: 'right' },
  { name: 'TOH Oud Metha', x: 66.80, y: 31.10, labelSide: 'left' },
  { name: 'TOH RAK', x: 75.21, y: 19.31, labelSide: 'left' },
  { name: 'TOH Al Ain', x: 71.64, y: 50.49, labelSide: 'left' },
  { name: 'NMC Al Ain', x: 68.85, y: 52.67, labelSide: 'left' },
];
